import { ProfileService } from './../../../services/profile.services';
import { catchError, tap, switchMap, finalize, take, takeWhile, map, mergeMap } from 'rxjs/operators';
import { OnInit, Component, AfterContentInit, OnDestroy } from '@angular/core';

import { Store } from '@ngrx/store';
import { AppState } from '../../store/AppState';
import {
  TaskDTO, TaskTypeDTO, DocumentFileTypeDTO, FileDetailsDTO,
  DocumentDTO, I18nData, TaskStatusDTO, ActionTypeDTO, SignatureValidationCode
} from '../../api/plyca-dtos';
import { TaskService } from '../task.service';
import { UserService } from '../../user.service';
import { generateRandomIdentifier, UIService } from '../../ui.service';
import { HeaderActionsService } from '../../components/common/sub-header/header-actions.service';
import { DocumentService } from '../../documents/document.service';
import { PlycaDataService } from '../../../services/plyca.service';
import { Configuration } from '../../conf/app.constants';
import { SignatureService } from '../../../services/signature.service';
import { from, EMPTY, Observable, of, Subscription, timer, throwError } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { WaitLoadingService } from '../../components/common/waitLoading/wait-loading.service';
import * as lodash from 'lodash';
import { BaseComponent } from '../../components/common/baseComponent/base.component';
import { HelpService, HelpType } from '../../components/common/help/help.service';
import { baseTaskComponent } from '../baseTask/baseTask.component';
import { ConfirmationService } from 'primeng-lts/api';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng-lts/dynamicdialog';
import { OverlayPanel } from 'primeng-lts/overlaypanel';
import { UserPrefs, TasksViewPrefs } from '../../api/UserPrefs-dto';
import { MultiDocumentViewerComponent } from '../../documents/documentViewer/multiDocumentViewer.component';
import { PlycaErrorHandler } from '../../../http/PlycaErrorHandler';
import { CertificateSelectionResponse, SignatureProviderType, SignatureRequest, SignatureResponse, SignatureStatus } from '../../../services/signature/signature.objects';

enum MultisignatureStatus {
  PENDING,
  RUNNING,
  PROCESSING_SIGNATURE,
  OK,
  ERROR
};

enum ProcessStatus {
  PENDING,
  SELECT_CERTIFICATE,
  SELECT_CERTIFICATE_ERROR,
  RUNNING,
  FINISHED,
  ABORTED
}


@Component({
  selector: 'multiSignature',
  templateUrl: 'multiSignature.template.html',
  providers: [DialogService, UIService]
})
export class multiSignatureComponent extends BaseComponent implements OnInit, AfterContentInit, OnDestroy {

  // CONSTANTES PARA GESTIONAR EL ESTADO DE LA FIRMA DE CADA TAREA
  readonly MESSAGE_PROPERTY = '_stateMessage';
  readonly STATUS_PROPERTY = '_signStatus';
  readonly SELECTED_PROPERTY = '_selected';
  readonly MultisignatureStatus = MultisignatureStatus;

  // estado del proceso
  readonly ProcessStatus = ProcessStatus;
  public processStatus = ProcessStatus.PENDING;

  public progressPercentage = 0;
  public signedTasks = 0;
  public errorTasks = 0;
  private _SIGNATURES = {};
  private documentErrors = 0;
  private dossierId = null;
  /**
   * Tareas de firma del usuario
   */
  public signatureTasks: Array<TaskDTO> = [];
  /**
   * tareas seleccionadas por el usuario para firmar
   */
  public task2Sign: Array<TaskDTO> = [];
  /**
   * tareas que muestra la tabla. Paso 1 -> todas las de firma, Paso 2 solo seleccionadas
   */
  public tableTasks: Array<TaskDTO> = [];
  public windowHash: string;
  public signatureMessage: string;

  // paso actual
  public currentStep = 1;

  private escapeSubscription: Subscription;
  private pendingTasksSubscription: Subscription;
  // INFORMACION DE LA PANTALLA ALMACENADA EN SESION
  userPrefs: UserPrefs;
  constructor(
    private store: Store<AppState>,
    protected taskService: TaskService,
    protected userService: UserService,
    protected documentService: DocumentService,
    protected plycaService: PlycaDataService,
    protected signatureService: SignatureService,
    protected configuration: Configuration,
    protected dialogConfig: DynamicDialogConfig,
    protected dialogService: DialogService,
    protected ref: DynamicDialogRef,
    private headerActionsService: HeaderActionsService,
    protected translateService: TranslateService,
    protected waitService: WaitLoadingService,
    protected uiService: UIService,
    protected confirmationService: ConfirmationService,
    protected helpService: HelpService,
    private profileService: ProfileService,
    private plycaErrorHandler: PlycaErrorHandler
  ) {
    super();
    this.subscribe(this.store
      .select('userPrefs'),
      (prefs: UserPrefs) => {
        this.userPrefs = prefs;

        if (!this.userPrefs.tasksViewPrefs) {
          this.userPrefs.tasksViewPrefs = new TasksViewPrefs();
        }
      });
    this.initSignatureSelection();
  }


  ngOnInit(): void {
    console.log('ngOnInit multiSignatureComponent *************************************************');
    this.subscribe(this.helpService.showContextHelpObservable(HelpType.MASSIVE_SIGNATURE));
    this.waitService.startWaiting(this.translateService.instant('Signature.AutoFirma.Connecting'));
    this.escapeSubscription = this.waitService.getEscapeObservable().subscribe(() => this.close());
    this.registerSubscription(this.escapeSubscription);
    this.signatureService.check(this.autofirmaCheckOK.bind(this), this.autofirmaCheckError.bind(this));
    this.subscribe(this.signatureService.getSignatures(), (signature: SignatureResponse) => {
      this.addSignature(signature);
    });
  }

  ngOnDestroy(): void {
    this.dialogConfig = null;
    this.dialogService = null;
    this.headerActionsService.clearWindowActions(this.windowHash);
    this.signatureService.cancelAllPendingSignatures();
    super.ngOnDestroy();
  }

  ngAfterContentInit(): void {
    this.windowHash = generateRandomIdentifier();
    this.headerActionsService.clearWindowActions(this.windowHash);
    // acción firmar
    this.subscribe(this.headerActionsService.addWindowAction(
      'DocumentView.sign',
      'fa fa-1-25x fa-file-signature',
      'btn-primary',
      () => this.currentStep === 1,
      this.windowHash,
      () => this.task2Sign.length > 0
    ), () => {
      if (!this.task2Sign.length) {
        this.uiService.showMessage(this.translateService.instant('Signature.Massive.Alert.EmptyTasks'), new I18nData('General.info'));
      } else {
        this.signDocuments();
      }
    });
    // acción cancelar
    this.subscribe(this.headerActionsService.addWindowAction(
      'General.cancel',
      'fas fa-stop',
      'btn-secondary',
      function () {
        return this.currentStep === 2 &&
          (this.processStatus === ProcessStatus.RUNNING || this.processStatus === ProcessStatus.SELECT_CERTIFICATE);
      }.bind(this),
      this.windowHash
    ), () => {
      this.subscribe(this.cancelProcess());
    });
    this.headerActionsService.addWindowDivider(this.windowHash);
    // acción cerrar ventana
    this.subscribe(this.headerActionsService
      .addWindowAction(
        'General.close',
        'fas fa-times',
        'btn-outline-secondary',
        true,
        this.windowHash
      ),
      () => {
        if (this.processStatus === ProcessStatus.RUNNING || this.processStatus === ProcessStatus.SELECT_CERTIFICATE) {
          this.confirmationService.confirm({
            message: this.translateService.instant('Signature.Massive.Alert.Close'),
            accept: () => {
              this.close();
            }
          });
        } else {
          this.close();
        }
      });
  }

  public autofirmaCheckOK(): void {
    this.waitService.cancelWaiting();
    this.unregisterSubscription(this.escapeSubscription);
  }


  public autofirmaCheckError(): void {
    this.waitService.cancelWaiting();
    this.unregisterSubscription(this.escapeSubscription);
    this.subscribe(this.uiService.showMessage(this.translateService.instant('Signature.AutoFirma.Error.Connection')).onClose,
      () => this.close());
  }

  public close() {
    if (this.processStatus === ProcessStatus.RUNNING) {
      this.subscribe(this.cancelProcess().pipe(
        finalize(() => {
          this.internalClose();
        })
      ));
    } else {
      this.internalClose();
    }
  }

  private internalClose(): void {
    this.ref.close();
  }

  public getStatusIcon(task: TaskDTO): string {
    if (task[this.STATUS_PROPERTY] === MultisignatureStatus.RUNNING
      || task[this.STATUS_PROPERTY] === MultisignatureStatus.PROCESSING_SIGNATURE) {
      return 'fa fa-spinner loading-spin fa-lg';
    } else if (task[this.STATUS_PROPERTY] === MultisignatureStatus.OK) {
      return 'fas fa-check text-success  fa-lg';
    } else if (task[this.STATUS_PROPERTY] === MultisignatureStatus.ERROR) {
      return 'fas fa-exclamation-circle text-danger fa-lg';
    }
  }

  public showSignatureMessage(task: TaskDTO, event: Event, overlaypanel: OverlayPanel): void {
    this.signatureMessage = task[this.MESSAGE_PROPERTY];
    overlaypanel.appendTo = 'body';
    if (this.signatureMessage) {
      overlaypanel.show(event);
    }
  }

  public getProcessMessage(): string {
    let message: string;
    switch (this.processStatus) {
      case ProcessStatus.PENDING: {
        message = this.translateService.instant('Signature.Massive.ProcessStatus.Pending');
        break;
      }
      case ProcessStatus.RUNNING: {
        message = this.translateService.instant('Signature.Massive.ProcessStatus.Running');
        break;
      }
      case ProcessStatus.FINISHED: {
        if (this.documentErrors || this.errorTasks) {
          message = this.translateService.instant('Signature.Massive.ProcessStatus.FinishERR');
        } else {
          message = this.translateService.instant('Signature.Massive.ProcessStatus.FinishOK');
        }
        break;
      }
      case ProcessStatus.ABORTED: {
        message = this.translateService.instant('Signature.Massive.ProcessStatus.Aborted');
        break;
      }
      case ProcessStatus.SELECT_CERTIFICATE_ERROR: {
        message = this.translateService.instant('Signature.Massive.ProcessStatus.CertificateERR');
        break;
      }
      case ProcessStatus.SELECT_CERTIFICATE: {
        message = this.translateService.instant('Signature.Massive.ProcessStatus.Certificate');
        break;
      }
    }
    return message;
  }

  public openTask(task: TaskDTO): void {
    let config: DynamicDialogConfig = {
      header: '',
      width: '90%',
      styleClass: 'formEdition',
      closeOnEscape: false,
      closable: false
    };
    config.data = {
      taskId: task.identifier
    }
    let ref = this.dialogService.open(baseTaskComponent, config);

    this.subscribe(ref.onClose,
      () => {
        this.waitService.startWaiting()
        this.subscribe(timer(3000), () => this.initSignatureSelection(true));
      }
    );
  }

  private signDocuments(): void {
    this.initSignatureProcess();
    if (this.task2Sign.length > 0) {
      console.log('iniciando proceso de firma., pedir certificado..');
      this.processStatus = ProcessStatus.SELECT_CERTIFICATE;
      this.documentErrors = 0;
      this.signedTasks = 0;
      this.errorTasks = 0;
      this._SIGNATURES = {};
      this.subscribe(this.signatureService.selectCertificate().pipe(
        tap((selection: CertificateSelectionResponse) => {
          console.log('resultado seleccion', selection);
          if (selection.status === SignatureStatus.ERROR || selection.status === SignatureStatus.CANCELLED) {
            if (selection.status === SignatureStatus.ERROR) {
              this.uiService.showMessage(selection.errorMessage, this.translateService.instant('General.error'), 'errorStyle');
            }
            this.processStatus = (selection.status === SignatureStatus.CANCELLED) ?
              ProcessStatus.ABORTED : ProcessStatus.SELECT_CERTIFICATE_ERROR;
          } else {
            this.processStatus = ProcessStatus.RUNNING;
            this.subscribe(from(this.task2Sign).pipe(
              takeWhile(() => this.processStatus !== ProcessStatus.ABORTED),
              mergeMap((task: TaskDTO, index: number) => this.processSignatureTask(selection, task, index))
            ));
          }
        })
      ));
    }
  }

  private processSignatureTask(certificate: CertificateSelectionResponse, task: TaskDTO, index: number) {
    let taskIdentifier = task.identifier;
    console.log('Procesando tarea con id', taskIdentifier, '...', task);
    return this.taskService.lockTask(taskIdentifier, true, false).pipe(
      catchError(err => {
        console.error('Error al bloquear la tarea con id', taskIdentifier, err);
        return this.markTaskError(task, this.translateService.instant('Signature.Massive.ErrorMsg.Lock'));
      }),
      takeWhile(() => this.processStatus !== ProcessStatus.ABORTED),
      tap((lockedTask: TaskDTO) => {
        console.log('Tarea bloqueada con id', taskIdentifier);
        this.updateTaskReference(lockedTask);
        lockedTask[this.STATUS_PROPERTY] = MultisignatureStatus.RUNNING;
        console.log('Estado de la tarea con id', task.identifier, ' cambiado a RUNNING');
        this.signDocument(certificate, lockedTask, null, index);
      })
    );
  }

  private signDocument(certificate: CertificateSelectionResponse, task: TaskDTO, comment: string, index: number) {
    // TODO Ojo con tareas de tipo FM que no tengan documentos en esta propiedad
    // WorkExpeseDocument
    let documents = task.work?.documents;
    let hastDocuments = false;
    if (documents) {
      // seleccionar documentos no firmados o no devueltos
      let documentsToSign = documents.filter((document: DocumentDTO) => this.documentHasAction(document, ActionTypeDTO.DOCUMENT_SIGN)
        || this.documentHasAction(document, ActionTypeDTO.DOCUMENT_REJECT));
      if (documentsToSign.length === 0) {
        // despachar tarea
        this.subscribe(this.dispatchSignatureTask(task));
      } else {
        // firmar pendientes
        documentsToSign.forEach((document: DocumentDTO) => {
          let oe_files = this.documentService.getTypeDocumentVersion(
            DocumentFileTypeDTO.Original,
            document.currentVersion
          );
          if (oe_files.length > 0) {
            hastDocuments = true;
            oe_files.forEach((file2Sign: FileDetailsDTO, docIndex: number) => {
              this._SIGNATURES[file2Sign.identifier] = task;
              let request = new SignatureRequest();
              request.file = file2Sign;
              request.documentClass = document.entity.documentClass;
              request.provider = SignatureProviderType.AFIRMA;
              if (certificate) {
                request.certificate = certificate.certificate;
              }
              console.log('Solicitando firma del documento de la tarea con id', task.identifier, '...', file2Sign);
              this.signatureService.sign(request);
            });
          }
        });
        if (!hastDocuments) {
          console.error('La tarea con id', task.identifier, 'no tiene originales electrónicos !!!', task);
          this.subscribe(this.unlockTask(task).pipe(
            tap((unlockedTask: TaskDTO) => {
              this.markTaskError(unlockedTask, this.translateService.instant('Signature.Massive.ErrorMsg.TaskWIthoutDocs'));
              this.updateProgress();
            })
          ));
        }
      }
    }
  }


  private documentHasAction(document: DocumentDTO, actionType: string): boolean {
    let hasAction = false;
    if (document?.availableActions) {
      let action = document.availableActions.actions.filter(
        x => x.identifier === actionType
      );
      hasAction = action.length > 0;
    }
    return hasAction;
  }

  private isDocumentSignature(signature: SignatureResponse, document: DocumentDTO) {
    return document.currentVersion.files.find(
      (originalFile: FileDetailsDTO) =>
        originalFile.identifier === signature.request.file.identifier
    );
  }

  private processSignatures(signatures: Array<SignatureResponse>, document: DocumentDTO, task: TaskDTO): Observable<boolean> {
    for (let i = 0; i < signatures.length; i++) {
      let signature = signatures[i];
      let idx = document.currentVersion.files.findIndex((originalFile: FileDetailsDTO) => {
        return originalFile.identifier === signature.request.file.identifier; //  original.identifier
      });
      if (idx !== -1) {
        document.currentVersion.files[idx] = signature.file; //   signature.signature;
        break;
      }
    }

    // no debe existir ningun OE sin firmas en todos los documentos de la tarea
    const pendigOESignatures = task.work.documents.find((workDocument: DocumentDTO) => workDocument?.currentVersion?.files
      && workDocument.currentVersion.files.find((file: FileDetailsDTO) =>
        file.fileType === DocumentFileTypeDTO.Original
        // pendiente de firma
        && this._SIGNATURES[file.identifier] !== undefined
      )) !== undefined;

    // actualizar documento en el servidor
    return this.plycaService.update<DocumentDTO>(this.configuration.DOCUMENTS_SERVICE_URL, document).pipe(
      map(() => pendigOESignatures)
    );
  }

  private addSignature(signature: SignatureResponse) {
    let task = this._SIGNATURES[signature.request.file.identifier];
    console.log('Documento de la tarea con id', (task) ? task.identifier : ' SIN TAREA!!! ', 'firmado', signature);
    if (task && task.work) {
      if (signature?.status === SignatureStatus.CANCELLED) {
        this.subscribe(this.cancelProcess());
      } else {
        // limpiar para que no se contabilice como fichero pendiente de firma
        this._SIGNATURES[signature.request.file.identifier] = undefined;
        if (this.processStatus === ProcessStatus.ABORTED) {
          console.log('El usuario a cancelado el proceso, se ignora la firma.');
        } else {
          const taskStatus = task[this.STATUS_PROPERTY];
          if (taskStatus === MultisignatureStatus.RUNNING) {
            task[this.STATUS_PROPERTY] = MultisignatureStatus.PROCESSING_SIGNATURE;
            console.log('Estado de la tarea con id', task.identifier, ' cambiado a PROCESSING_SIGNATURE');
          }
          for (let i = 0; i < task.work.documents.length; i++) {
            let document = task.work.documents[i];
            let signatures = new Array<SignatureResponse>();
            if (signature && this.isDocumentSignature(signature, document)) {
              signatures.push(signature);
              if (signature.signatureStatus === SignatureValidationCode.OK) {
                // procesar las firmas
                this.subscribe(this.processSignatures(signatures, document, task).pipe(
                  catchError((error: any) => {
                    console.error('Error al actualizar documento con id', document.identifier);
                    return this.markTaskError(task, this.translateService.instant('Signature.Massive.ErrorMsg.Document'));
                  }),
                  switchMap((pendigOESignatures: boolean) => {
                    // despachamos la tarea solo si están todos los OE firmados
                    if (!pendigOESignatures) {
                      console.log('Consultando tarea con id', task.identifier, '...');
                      return this.taskService.getTaskWithActions(task.identifier).pipe(
                        catchError((error: any) => {
                          console.error('Error al consultar obtener la tarea actualizada', task.identifier, error);
                          return this.markTaskError(task, this.translateService.instant('Signature.Massive.ErrorMsg.Save'));
                        }),
                        switchMap((updatedTask: TaskDTO) => {
                          if (updatedTask) {
                            // copiar propiedades proceso antes de cambiar referencia
                            updatedTask[this.STATUS_PROPERTY] = task[this.STATUS_PROPERTY];
                            updatedTask[this.MESSAGE_PROPERTY] = task[this.MESSAGE_PROPERTY];
                            task = updatedTask;
                            this.updateTaskReference(task);
                            console.log('Despachando de la tarea con id', task.identifier, ' ...');
                            return this.dispatchSignatureTask(task)
                          }
                        })
                      );
                    } else {
                      // continuar ejecucion
                      console.error('Quedan documentos pendiente por firmar en la tarea con id', task.identifier);
                      return of({});
                    }
                  })
                ));
              } else {
                this.documentErrors++;
                console.log('Desbloqueando la tarea con id', task.identifier, ' ...');
                // desbloquear tarea
                this.subscribe(this.unlockTask(task).pipe(
                  tap((unlockedTask: TaskDTO) => {
                    let errorMsg: string;
                    if (signature.status === SignatureStatus.ERROR) {
                      errorMsg = signature.errorMessage;
                    } else if (signature.signatureStatus && signature.signatureStatus !== SignatureValidationCode.OK) {
                      errorMsg = this.translateService.instant('ValidateSignDocument.result.validate.'
                        + signature.signatureStatus);
                    } else if (signature?.errorMessage) {
                      errorMsg = signature.errorMessage;
                    } else {
                      errorMsg = unlockedTask[this.MESSAGE_PROPERTY]
                    }
                    this.markTaskError(unlockedTask, errorMsg);
                    console.log('Estado de la tarea con id', task.identifier, ' cambiado a ERROR');
                  }),
                  finalize(() => this.updateProgress())
                ));
              }
              break;
            } else {
              console.warn('La firma no se corresponde a la tarea con id', task.identifier, 'y documento', document.identifier);
            }
          };
        }
      }
    } else {
      console.error('La firma no se corresponde a un ninguna tarea seleccionada');
    }
  }
  private dispatchSignatureTask(task: any): Observable<any> {
    return this.taskService.dispatchTask(task).pipe(
      catchError((error: any) => {
        console.error('Error al despachar la tarea con id', task.identifier, error);
        return this.markTaskError(task, this.translateService.instant('Signature.Massive.ErrorMsg.Unlock'));
      }),
      tap(value => {
        if (value) {
          // HACK PARA QUE LA TAREA DEJE DE APARECER BLOQUEADA
          task.status = TaskStatusDTO.READY;
          task[this.STATUS_PROPERTY] = MultisignatureStatus.OK;
          console.log('Estado de la tarea con id', task.identifier, ' cambiado a OK');
          this.signedTasks++;
          this.updateProgress();
          // borrar la tarea de la lista de tareas de firma pendientes
          this.signatureTasks.filter((signatureTask: TaskDTO) => signatureTask.identifier !== task.identifier);
        }
      })
    );
  }

  private updateProgress() {
    this.progressPercentage = Math.round(((this.signedTasks + this.errorTasks) / this.tableTasks.length) * 100);
    if ((this.signedTasks + this.errorTasks) === this.tableTasks.length) {
      this.processStatus = ProcessStatus.FINISHED;
    }
  }

  private unlockTask(task: TaskDTO): Observable<TaskDTO> {
    return this.taskService.unlockTask(task, false).pipe(
      catchError((error: any) => {
        console.error('Error al desbloquear con id', task.identifier, error)
        return this.markTaskError(task, this.translateService.instant('Signature.Massive.ErrorMsg.Unlock'));
      }),
      tap((unlockedTask: TaskDTO) => {
        console.log('Tarea con id', task.identifier, ' desbloqueada');
        task[this.STATUS_PROPERTY] = undefined;
        this.updateTaskReference(unlockedTask, true);
      })
    );
  }

  private markTaskError(task: TaskDTO, message: string): Observable<never> {
    // consultar tarea existente en la lista
    let tableTaskAux = this.tableTasks.find(tableTask => tableTask.identifier === task.identifier);
    if (tableTaskAux && tableTaskAux[this.STATUS_PROPERTY] !== MultisignatureStatus.ERROR) {
      this.errorTasks++;
    }
    // guardo una copia en la tabla para no actualizar el objeto de tareas compartido por la aplicacion
    let _task = lodash.cloneDeep(task);
    _task[this.STATUS_PROPERTY] = MultisignatureStatus.ERROR;
    console.log('Estado de la tarea con id', task.identifier, ' cambiado a ERROR');
    _task[this.MESSAGE_PROPERTY] = message;
    this.updateTaskReference(_task);
    this.updateProgress();
    // devolvemos EMPTY para no pasar por el siguiente operador del pipe e ir al finally
    return EMPTY;
  }

  private updateTaskReference(task: TaskDTO, keepStatus = false): void {
    // Actualizar la tarea en la tabla para mostrar resultados
    let idx = this.tableTasks.findIndex(_task => _task.identifier === task.identifier);
    const prevTask = this.tableTasks[idx];
    if (keepStatus) {
      task[this.STATUS_PROPERTY] = prevTask[this.STATUS_PROPERTY];
      task[this.MESSAGE_PROPERTY] = prevTask[this.MESSAGE_PROPERTY];
    }
    this.tableTasks[idx] = task;
    this.tableTasks = [...this.tableTasks];
  }

  private initSignatureSelection(cancelWaiting = false): void {
    this.signatureTasks.splice(0);
    // darse de baja de suscripciones anteriores si las hubiera
    this.unregisterSubscription(this.pendingTasksSubscription);
    this.pendingTasksSubscription = this.subscribe(this.store
      .select('pendingTasks')
      .pipe(
        take(1),
        tap((tasks: Array<TaskDTO>) => {
          // TODO exluir tramites pausados
          // cargar datos en lista signatureTasks
          tasks.filter((task: TaskDTO) => task.type === TaskTypeDTO.TIPO_FIRMA
            && task.workType === 'DOCUMENTSIGNATURE'
            && !task.lockedForSupport
            && !this.taskService.isLockedTask(task))
            .forEach((task: TaskDTO) => {
              if (!this.dialogConfig.data?.dossierId || task.division?.project?.identifier == this.dialogConfig.data.dossierId) {
                let _task = lodash.cloneDeep(task);
                _task[this.STATUS_PROPERTY] = MultisignatureStatus.PENDING;
                _task[this.SELECTED_PROPERTY] = false;
                console.log('Estado de la tarea con id', task.identifier, ' cambiado a PENDING');
                this.signatureTasks.push(_task);
              }
            });
          // cargar datos de la lista signatureTasks en la lista de la tabla e inicializar
          this.tableTasks = this.signatureTasks;
          console.log('Tabla con tareas de firma. cargada.')
          this.progressPercentage = 0;
          this.currentStep = 1;
          if (cancelWaiting) {
            this.waitService.cancelWaiting();
          }
        }
        )
      )
    );
  }

  private initSignatureProcess(): void {
    this.tableTasks = this.task2Sign;
    this.currentStep++;
  }

  /**
 * Desbloquear las tareas bloqueadas
 */
  private unlockLockedTasks(): Observable<any> {
    // desbloquear tareas bloqueadas que no esten actualmente procesando una firma (en ese caso el metodo de procesado desbloquea)
    let pendingTasks = this.tableTasks
      .filter((task: TaskDTO) => task.status === 'LOCKED' && task[this.STATUS_PROPERTY] !== MultisignatureStatus.PROCESSING_SIGNATURE);
    console.log('Tareas a desbloquear ', pendingTasks, '...');
    return from(pendingTasks).pipe(
      mergeMap((task: TaskDTO) => this.unlockTask(task)
      ));
  }

  private cancelProcess(): Observable<any> {
    console.log('Cancelando proceso...');
    this.waitService.startWaiting(this.translateService.instant('Signature.Massive.CancelProcess'));
    this.processStatus = ProcessStatus.ABORTED;
    console.log('Solicitando cancelacion de firmas pendientes...');
    this.signatureService.cancelAllPendingSignatures();
    return this.unlockLockedTasks().pipe(
      finalize(() => this.waitService.cancelWaiting())
    );
  }

  getTaskProfile(task: TaskDTO): string {
    if (!task.profile) {
      return '';
    }
    let profile = this.profileService.getProfile(task.profile.identifier);
    return profile ? profile.description : '';
  }

  public viewDocument(task: TaskDTO): void {
    this.waitService.startWaiting();
    this.subscribe(
      this.taskService.lockTask(task.identifier, false, false).pipe(
        catchError(error => {
          console.error(error);
          this.plycaErrorHandler.showServerError(error);
          return throwError(error);
        }),
        mergeMap((openedTask: TaskDTO) => {
          let documents = openedTask?.work?.documents
          if (!documents || documents.length === 0) {
            this.waitService.cancelWaiting();
            this.uiService.showMessage(this.translateService.instant('La tarea no tiene documentos'));
            this.waitService.startWaiting();
            documents = null;
          }
          return this.taskService.unlockTask(openedTask, true).pipe(
            catchError(error => {
              this.plycaErrorHandler.showServerError(error);
              return throwError(error);
            }),
            finalize(() => {
              if (documents) {
                this.openDocument(documents);
              } else {
                this.waitService.cancelWaiting();
              }
            })
          );
        })
      )
    );
  }

  private openDocument(documents: DocumentDTO[]) {
    // let config: DynamicDialogConfig = {
    //   header: doc.name,
    //   width: '97%',
    //   styleClass: 'searchStyle'
    // };
    // config.data = {
    //   'id': doc.identifier
    // }
    // this.waitService.startWaiting();
    // let modal = this.dialogService.open(documentViewerComponent, config);
    // this.subscribe(modal.onClose);
    let config: DynamicDialogConfig = {
      // TODO i18n
      header: 'Detalle del documento',
      width: '97%',
      styleClass: 'searchStyle'
    };
    config.data = {
      documentIdentifiers: documents.map((doc: DocumentDTO) => doc.identifier)
    }
    this.waitService.startWaiting();
    this.dialogService.open(MultiDocumentViewerComponent, config);
  }
}